var map = {
	"./RCDEMO_loginlogo.svg": 22316,
	"./RUNMYBOT_loginlogo.svg": 5736,
	"assetts/images/RCDEMO_loginlogo.svg": 22316,
	"assetts/images/RUNMYBOT_loginlogo.svg": 5736
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15371;